/** Vérification du mot de passe de la console d'administration. */

const ADMIN_SALT = 'terminal.nsi.xyz:admin';
const ADMIN_ITERATIONS = 100_000;
const HASH_LENGTH = 64;

export function hashAdminPassword(password: string): Promise<string> {
  return (async () => {
    const material = await crypto.subtle.importKey(
      'raw',
      new TextEncoder().encode(password),
      'PBKDF2',
      false,
      ['deriveBits'],
    );
    const bits = await crypto.subtle.deriveBits(
      {
        name: 'PBKDF2',
        salt: new TextEncoder().encode(ADMIN_SALT),
        iterations: ADMIN_ITERATIONS,
        hash: 'SHA-256',
      },
      material,
      256,
    );
    return [...new Uint8Array(bits)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
  })();
}

/** La console n'est disponible que si ADMIN_PASSWORD a été défini au build. */
export function adminConsoleConfigured(): boolean {
  return (
    typeof __ADMIN_PASSWORD_HASH__ === 'string' && __ADMIN_PASSWORD_HASH__.length === HASH_LENGTH
  );
}

export async function verifyAdminPassword(password: string): Promise<boolean> {
  if (!adminConsoleConfigured()) return false;
  return (await hashAdminPassword(password)) === __ADMIN_PASSWORD_HASH__;
}
